/*eslint-disable*/
import axiosIndex from './axios/index';
import filterIndex from './filter/infoFilter';
import formIndex from './form/index';
import INformIndex from './form/INindex';
import urlsIndex from './urls/url';
import commonIndex from './utils/common';
import commonApiIndex from './utils/commonApi';
import storeIndex from './store/index';

export const  axios = axiosIndex;
export const  filter = filterIndex;
export const  check = formIndex;
export const  INcheck = INformIndex;     //印度验证
export const  urls = urlsIndex;
export const  common = commonIndex;
export const  commonApi = commonApiIndex;
export const  store = storeIndex;



// WEBPACK FOOTER //
// ./src/common/index.js